import CompanyServices from "@/services/CompanyService";
import handleAlert from "@/utils/HandleAlert";
import { removePage, setPage } from "@/utils/HandleToken";

export default {
  namespaced: true,
  state: {
    form: {},

    search: "",
    limit: 10,

    datas: [],
    pagination: {},

    detail: {},
    listCompany: [],
  },
  mutations: {
    SET_FORM(state, value) {
      state.form = value;
    },
    SET_DATAS(state, value) {
      state.datas = value;
    },
    SET_PAGINATION(state, value) {
      state.pagination = value;
    },
    SET_SEARCH(state, value) {
      state.search = value;
    },
    SET_DETAIL(state, value) {
      state.detail = value;
    },
    SET_LIST_COMPANY(state, value) {
      state.listCompany = value;
    },
  },
  actions: {
    async saveCreate({ commit, state, rootState, dispatch }) {
      state.form.ucreated = rootState.Auth.userData.username;
      try {
        const result = await CompanyServices.create(state.form);
        handleAlert({ commit, dispatch }, result, null);
        commit("SET_FORM", {});
        dispatch("readAll", state.pagination.currentPage);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async readAll({ commit, state, dispatch }, payload) {
      removePage();
      const form = {
        search: state.search,
        pagination: {
          limit: state.limit,
          page: payload,
        },
      };
      try {
        const result = await CompanyServices.findAll(form);
        commit("SET_DATAS", result.data.data);
        commit("SET_PAGINATION", result.data.pagination);
        // handleAlert({ commit, dispatch }, result, null);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      } finally {
        setPage(payload);
      }
    },
    async readOne({ commit, dispatch }, payload) {
      try {
        const result = await CompanyServices.findOne({ compcode: payload });
        commit("SET_DETAIL", result.data);
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async delete({ commit, state, dispatch }, payload) {
      try {
        const { id, closeModal } = payload;
        const result = await CompanyServices.delete({ compcode: id });
        handleAlert({ commit, dispatch }, result, null);
        console.log(state.pagination.currentPage);
        if (result.meta.code == 201) {
          dispatch("readAll", state.pagination.currentPage);
          closeModal.click();
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async update({ commit, state, dispatch }, payload) {
      try {
        const result = await CompanyServices.update(payload);
        handleAlert({ commit, dispatch }, result, null);
        if (result.meta.code === 201) {
          commit("SET_DETAIL", result.data);
          dispatch("readAll", state.pagination.currentPage);
        }
      } catch (error) {
        handleAlert({ commit, dispatch }, null, error);
      }
    },
    async readList({ commit, dispatch }) {
      try {
        const result = await CompanyServices.findList();
        commit("SET_LIST_COMPANY", result.data);
      } catch (error) {
        commit("SET_LIST_COMPANY", []);
        handleAlert({ commit, dispatch }, null, error);
      }
    },
  },
  getters: {},
};
